/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ab_Otp_P_BeforeInputs */

const es_ab_otp_p_before = /** @type {(inputs: Ab_Otp_P_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hemos enviado un código de verificación a `)
};

const gl_ab_otp_p_before = /** @type {(inputs: Ab_Otp_P_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviamos un código de verificación a `)
};

const en_ab_otp_p_before = /** @type {(inputs: Ab_Otp_P_BeforeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We sent a verification code to `)
};

/**
* | output |
* | --- |
* | "We sent a verification code to" |
*
* @param {Ab_Otp_P_BeforeInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const ab_otp_p_before = /** @type {((inputs?: Ab_Otp_P_BeforeInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ab_Otp_P_BeforeInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_ab_otp_p_before(inputs)
	if (locale === "en") return en_ab_otp_p_before(inputs)
	return es_ab_otp_p_before(inputs)
});